<template>
    <div v-if="$store.showErrorPopup" class="error-popup-component-container">
        <div class="error-popup-component-wrapper">
            <div class="error-popup-msg-container">
                <div class="error-popup-title-container">
                    <div class="error-popup-title-wrapper">
                        <p>{{ $t(`${$store.errorPopupTitle}`) }}</p>
                    </div>
                </div>
                <div class="error-popup-content-container">
                    <div v-if="!$store.flutterAppMustBeUpdated" class="error-popup-content-msg-container">
                        <p>{{ $t(`${$store.errorPopupMsg}`) }}</p>
                    </div>
                    <div v-if="!$store.flutterAppMustBeUpdated" class="ok-btn-container">
                        <div class="ok-btn-wrapper">
                            <div class="ok-btn" @click="closeErrPopup">
                                <!-- <p>{{ $t('ok') }}</p> -->
                                <img src="../assets/icons/check.png" alt="Check Image">
                            </div>
                        </div>
                    </div>
                    <div v-else class="update-app-message-container">
                        <div class="update-app-message-wrapper">
                            <!-- <div class="update-app-btn android-btn" @click="updateApp('Android')">
                                <p>{{ $t('Android') }}</p>
                            </div>
                            <div class="update-app-btn ios-btn" @click="updateApp('IOS')">
                                <p>{{ $t('IOS') }}</p>
                            </div> -->
                            <!-- <p class="time-for-update-text">{{ $t('time_for_update') }}</p> -->
                            <!-- <p class="install-new-version-text">You’re using an older version of the app. Please open the Google Play Store or App Store, search for <span class="app-name">fit20</span> app, and install the latest update.</p> -->
                             <p class="install-new-version-text" v-html="$t('update_message', { appName: 'fit20' })"></p>
                            <p class="notice-text">{{ $t('update_message_notice') }}</p>
                        </div>

                        <!-- <div class="update-btn-container">
                            <div class="update-btn-wrapper" @click="updateApp">
                                <div class="update-btn">
                                    <p>{{ $t('update') }}</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorPopupComponent',
    data() {
        return {
        }
    },
    methods: {
        closeErrPopup: async function () {
            if (this.$store.mustLogOut) {
                await this.$store.logOut();
                this.$router.push('/start');
            }
            if (this.$store.errorPopupMsg == "profile_image_changed_successfully") {
                this.$store.reloadHeaderApp++;
            }
            
            this.$store.showErrorPopup = false;
            this.$store.errorPopupMsg = '';
        },
        updateApp: async function () {
            // if (platform == 'Android') {
            //     // const intentStoreUrl = 'https://play.google.com/store/apps/details?id=com.fit20.app';
            //     // const intentStoreUrl = 'intent://details?id=com.fit20.app#Intent;scheme=market;package=com.android.vending;end';
            //     // const intentStoreUrl = 'market://details?id=com.fit20.app';
            //     // this.$store.openExternalUrl(intentStoreUrl);
            //     // window.open(intentStoreUrl, '_blank');
            //     // window.location.href = intentStoreUrl;
            //     window.location.href = "https://play.google.com/store/apps/details?id=com.fit20.app";
            // }
            // else if (platform == 'IOS') {
            //     const intentStoreUrl = 'https://apps.apple.com/app/id6575379193';
            //     this.$store.openExternalUrl(intentStoreUrl);
            // }
            // console.log("Update app...");
            await window.open_store_channel.postMessage(JSON.stringify({message: "openStore"}));
        },
    }
}
</script>

<style>
.error-popup-component-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
    z-index: 150;
}

.error-popup-component-container .error-popup-component-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    overflow: auto;
    /* border-radius: 5px 5px 25px 25px; */
    /* background: #ffffff; */
    /* border: 1px solid #d6d9d9; */
}

.error-popup-component-container .error-popup-msg-container {
    width: 85%;
    max-width: 500px;
    min-width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 22px;
    background: #ffffff;
    margin: 20px 0;
    border: 2px solid #92d400;
}

.error-popup-component-container .error-popup-title-container {
    /* width: 85%;
    max-width: 500px;
    padding: 8px 20px;
    border-top: 1px solid #d6d9d9;
    border-bottom: 1px solid #d6d9d9;
    border-radius: 5px 5px 0 0; */
    width: 100%;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    background: #92d400;
}

.error-popup-component-container .error-popup-title-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 6px 15px 5px;
}

[dir="rtl"] .error-popup-component-container .error-popup-title-wrapper {
    padding: 0px 15px;
}

.error-popup-component-container .error-popup-title-wrapper p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #ffffff;
    padding: 4px 0;
}

[dir="rtl"] .error-popup-component-container .error-popup-title-wrapper p {
    font-size: 22px;
}

.error-popup-component-container .error-popup-content-container {
    width: 100%;
    /* display: flex;
    flex-direction: column;
    justify-content: center; */
    padding: 10px 15px;
}

.error-popup-component-container .error-popup-content-msg-container p {
    font-family: 'Open Sans Std', sans-serif;
    font-size: 20px;
    color: #616365;
    letter-spacing: -1px;
    /* white-space: pre-line; */
}

.error-popup-component-container .ok-btn-container {
    /* width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 10px; */
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0 5px;
}

.error-popup-component-container .ok-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #009df4;
    padding: 1px 30px;
    border-radius: 30px;
    overflow: hidden;
    cursor: pointer;
}

.error-popup-component-container .ok-btn {
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: 5px 0;
}

.error-popup-component-container .ok-btn img {
    width: 90%;
    /* border: 1px solid red; */
}

.error-popup-component-container .update-app-message-container {
    width: 100%;
    /* height: 39px; */
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    /* margin: 15px 0 5px; */
}

.error-popup-component-container .update-app-message-wrapper {
    width: 100%;
    height: 100%;
    /* max-width: 300px; */
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    padding: 4px 0;
    border-radius: 30px;
    /* overflow: hidden; */
    cursor: pointer;
}

.error-popup-component-container .update-app-message-wrapper .time-for-update-text {
    font-size: 20px;
    font-family: 'Open Sans Std', sans-serif;
    color: #009df4;
    /* letter-spacing: -1px; */
    padding-bottom: 10px;
}

.error-popup-component-container .update-app-message-wrapper .install-new-version-text {
    font-size: 16px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
    /* letter-spacing: -1px; */
    padding-bottom: 10px;
    /* font-weight: bold; */
}

.error-popup-component-container .update-app-message-wrapper .install-new-version-text .app-name {
    font-weight: bold;
    color: #009df4;
}

.error-popup-component-container .update-app-message-wrapper .notice-text {
    font-size: 16px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
    /* letter-spacing: -1px; */
    padding-bottom: 4px;
    /* font-weight: bold; */
}

.error-popup-component-container .update-btn-container {
    width: 100%;
    /* height: 40px; */
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0 5px;
}

.error-popup-component-container .update-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #009df4;
    padding: 1px 30px;
    border-radius: 30px;
    overflow: hidden;
    cursor: pointer;
}

.error-popup-component-container .update-btn-container .update-btn {
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* overflow: hidden; */
    margin: 5px 0;
}

.error-popup-component-container .update-btn-container .update-btn p {
    font-size: 20px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #ffffff;
    padding: 4px 0;
}

/* .error-popup-component-container .update-app-btn {
    width: 50%;
    max-width: 150px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 1px 10px;
    border-radius: 30px;
}

.error-popup-component-container .android-btn {
    background: #92d400;
}

.error-popup-component-container .ios-btn {
    background: #009df4;
}

.error-popup-component-container .update-app-btn p {
    font-size: 20px;
    font-family: 'Open Sans Std', sans-serif;
    color: #ffffff;
    letter-spacing: -1px;
} */



@media (max-width: 425px) {
    .error-popup-component-container .error-popup-title-wrapper p {
        font-size: calc(18px + 1.5vw);
    }

    .error-popup-component-container .error-popup-content-msg-container p {
        font-size: calc(13px + 1.5vw);
    }
}

@media (max-width: 375px) {
    .error-popup-component-container .ok-btn-wrapper {
        padding: 1px 25px;
    }

    .error-popup-component-container .ok-btn {
        width: 32px;
    }
}

</style>